var map = {
	"./AC.png": "a532",
	"./AD.png": "53ea",
	"./AE.png": "1dc5",
	"./AF.png": "770f",
	"./AG.png": "2818",
	"./AI.png": "fb8b",
	"./AL.png": "3604",
	"./AM.png": "d6b8",
	"./AN.png": "f794",
	"./AO.png": "07da",
	"./AQ.png": "45d4",
	"./AR.png": "4b8b8",
	"./AS.png": "433d",
	"./AT.png": "83d6",
	"./AU.png": "c621",
	"./AW.png": "a4fe",
	"./AX.png": "c2a8",
	"./AZ.png": "350f",
	"./BA.png": "5a9b",
	"./BB.png": "e252",
	"./BD.png": "ab42",
	"./BE.png": "f8c4",
	"./BF.png": "5b9c",
	"./BG.png": "fb1d",
	"./BH.png": "a39f",
	"./BI.png": "6df7",
	"./BJ.png": "b854",
	"./BL.png": "1d66",
	"./BM.png": "90fd",
	"./BN.png": "6dae",
	"./BO.png": "430d",
	"./BQ.png": "c7df",
	"./BR.png": "56cd",
	"./BS.png": "81b5",
	"./BT.png": "30e7",
	"./BV.png": "ce9c",
	"./BW.png": "2895",
	"./BY.png": "541e",
	"./BZ.png": "2aec",
	"./CA.png": "6a8d",
	"./CC.png": "8631",
	"./CD.png": "f85e",
	"./CF.png": "4377",
	"./CG.png": "68fd",
	"./CH.png": "593e",
	"./CI.png": "2eee",
	"./CK.png": "b50a",
	"./CL.png": "94cb",
	"./CM.png": "1343",
	"./CN.png": "a29a",
	"./CO.png": "eb9d",
	"./CP.png": "a545",
	"./CR.png": "74a4",
	"./CS.png": "2b7b",
	"./CT.png": "5825",
	"./CU.png": "a196",
	"./CV.png": "bb49",
	"./CW.png": "1e5a5",
	"./CX.png": "08d4",
	"./CY.png": "4f57",
	"./CZ.png": "ec59",
	"./DE.png": "b0b4",
	"./DG.png": "9dad",
	"./DJ.png": "520c",
	"./DK.png": "8b4b",
	"./DM.png": "48c4",
	"./DO.png": "cae9",
	"./DZ.png": "67a4",
	"./EA.png": "d7fd",
	"./EC.png": "5823",
	"./EE.png": "0f56",
	"./EG.png": "c6d4",
	"./EH.png": "9825",
	"./ER.png": "dde1",
	"./ES.png": "b070",
	"./ET.png": "244c",
	"./EU.png": "e7ad",
	"./FI.png": "a2db",
	"./FJ.png": "4402",
	"./FK.png": "6c23",
	"./FM.png": "cf9e",
	"./FO.png": "2325",
	"./FQ.png": "246b",
	"./FR-MF.png": "e83a",
	"./FR-YT.png": "37fc",
	"./FR.png": "e654",
	"./FX.png": "e2ca",
	"./GA.png": "55d1",
	"./GB.png": "6e71",
	"./GD.png": "059d",
	"./GE.png": "6504",
	"./GF.png": "414e",
	"./GG.png": "3cbe",
	"./GH.png": "3caf",
	"./GI.png": "6cc2",
	"./GL.png": "c880",
	"./GM.png": "fc5ec",
	"./GP.png": "fc25",
	"./GQ.png": "b783",
	"./GR.png": "c912",
	"./GS.png": "8cea",
	"./GT.png": "45f2",
	"./GU.png": "adb2",
	"./GW.png": "2d1d",
	"./GY.png": "4eef",
	"./HK.png": "4c6c",
	"./HN.png": "5d35",
	"./HR.png": "e0653",
	"./HT.png": "55cf",
	"./HU.png": "e19d",
	"./IC.png": "f7d9",
	"./ID.png": "68d4",
	"./IE.png": "8a37",
	"./IL.png": "23f7",
	"./IM.png": "6b1d",
	"./IN.png": "9820",
	"./IO.png": "aae6",
	"./IQ.png": "c795",
	"./IS.png": "5759",
	"./IT.png": "4acc",
	"./JE.png": "8974",
	"./JM.png": "359c",
	"./JO.png": "ff94",
	"./JP.png": "77c4",
	"./KE.png": "4031",
	"./KG.png": "4046",
	"./KH.png": "74b4",
	"./KI.png": "a7dd",
	"./KM.png": "ac84",
	"./KN.png": "9ff7",
	"./KP.png": "79b5",
	"./KR.png": "c3ad",
	"./KW.png": "5b17",
	"./KY.png": "fa5d",
	"./KZ.png": "598a",
	"./LA.png": "1e9b",
	"./LC.png": "0587",
	"./LI.png": "e10c",
	"./LK.png": "c754",
	"./LR.png": "1322",
	"./LS.png": "1d81",
	"./LT.png": "9b1d",
	"./LU.png": "6c7b",
	"./LV.png": "769c",
	"./LY.png": "96ce",
	"./MA.png": "b433",
	"./MC.png": "8882",
	"./MD.png": "92bf",
	"./ME.png": "5eb3",
	"./MF.png": "af71",
	"./MG.png": "78dd",
	"./MH.png": "419a",
	"./MI.png": "69ca",
	"./MK.png": "3f50",
	"./ML.png": "b0f8",
	"./MM.png": "1c0c",
	"./MN.png": "27b4",
	"./MO.png": "ab91",
	"./MP.png": "fc93",
	"./MQ.png": "f7b9",
	"./MR.png": "7306",
	"./MS.png": "8106",
	"./MT.png": "f40c",
	"./MU.png": "f8bf",
	"./MV.png": "d7e8",
	"./MW.png": "3335",
	"./MX.png": "397b",
	"./MY.png": "46b9",
	"./MZ.png": "bbf5",
	"./NA.png": "57b5",
	"./NC.png": "4d8b",
	"./NE.png": "6aff",
	"./NF.png": "f864",
	"./NG.png": "0e9b",
	"./NI.png": "23ba",
	"./NL.png": "d3b0",
	"./NO.png": "6129",
	"./NP.png": "9be2",
	"./NQ.png": "f479",
	"./NR.png": "70ab",
	"./NT.png": "2f8b",
	"./NU.png": "dc1f",
	"./NZ.png": "e331",
	"./OM.png": "ea8f",
	"./PA.png": "3413",
	"./PC.png": "937b",
	"./PE.png": "61b9",
	"./PF.png": "0a3c",
	"./PG.png": "8f3c",
	"./PH.png": "ff99",
	"./PK.png": "272f",
	"./PL.png": "5390",
	"./PM.png": "022d",
	"./PN.png": "ab46",
	"./PR.png": "2967",
	"./PS.png": "2dfd",
	"./PT.png": "6474",
	"./PU.png": "b957",
	"./PW.png": "df758",
	"./PY.png": "ff12",
	"./PZ.png": "f1ea",
	"./QA.png": "101b",
	"./QO.png": "43f5e",
	"./RE.png": "9150",
	"./RO.png": "3e10",
	"./RS.png": "9ebe",
	"./RU.png": "709c",
	"./RW.png": "6bfd",
	"./SA.png": "7a87",
	"./SB.png": "dfb5",
	"./SC.png": "b327",
	"./SD.png": "60b6",
	"./SE.png": "e381",
	"./SG.png": "9af1",
	"./SH-HL.png": "e748",
	"./SH.png": "7735",
	"./SI.png": "df5f",
	"./SJ.png": "3957",
	"./SK.png": "21c5",
	"./SL.png": "8d05",
	"./SM.png": "ebb2",
	"./SN.png": "e01c",
	"./SO.png": "24ab",
	"./SR.png": "613e",
	"./SS.png": "3b04",
	"./ST.png": "15b6",
	"./SV.png": "d9b52",
	"./SX.png": "784f",
	"./SY.png": "f244",
	"./SZ.png": "77f9",
	"./TA.png": "6fdb",
	"./TC.png": "31df",
	"./TD.png": "8a5d",
	"./TF.png": "fa28",
	"./TG.png": "a332",
	"./TH.png": "eae8",
	"./TJ.png": "8b41",
	"./TK.png": "3ffd",
	"./TL.png": "41c0",
	"./TM.png": "fa4a",
	"./TN.png": "6d14",
	"./TO.png": "821c",
	"./TR.png": "639b",
	"./TT.png": "aaa5",
	"./TV.png": "5020",
	"./TW.png": "2108",
	"./TZ.png": "84e7",
	"./UA.png": "afea",
	"./UG.png": "53da",
	"./UM.png": "0ba3",
	"./US.png": "999d",
	"./UY.png": "adc5",
	"./UZ.png": "0de0",
	"./VA.png": "12eb",
	"./VC.png": "8786",
	"./VD.png": "6962",
	"./VE.png": "799e",
	"./VG.png": "1d0d",
	"./VI.png": "4b12",
	"./VN.png": "d555",
	"./VU.png": "5c65",
	"./WF.png": "6a01",
	"./WK.png": "bfa1",
	"./WS.png": "f051",
	"./YD.png": "3d32",
	"./YE.png": "fc34",
	"./YT.png": "3925",
	"./ZA.png": "a2a2",
	"./ZM.png": "e51b",
	"./ZW.png": "1171",
	"./empty.png": "7e8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2045";